import ArrowExpand from './src/arrow-expand-combined';
export default ArrowExpand;